<script lang="ts" setup>
import { useStorage } from '@vueuse/core';
import { DateTime, Interval, type DurationLikeObject } from 'luxon';
import { useDefaultProgramme } from '~/composables/useDefaultProgramme';
import { useGlobalMerchant } from '~/composables/useGlobalMerchant';
import { getProgrammeApplicationStatus } from '~~/models/Programme';

const { programme } = useDefaultProgramme();

const storageKey = computed(() => programme.value ? `has-acknowledged-rejection-modal-${programme.value.merchantId}` : '');

const hasAcknowledgedModal = useStorage<boolean>(storageKey, false, undefined, { writeDefaults: false });

const showModal = ref(false);

const VALID_APPLICATION_AGE: DurationLikeObject = { days: 14 };

watch(programme, () => {
	if (!programme.value) {
		return;
	}

	if (hasAcknowledgedModal.value) {
		showModal.value = false;
		return;
	}

	const isRejected = getProgrammeApplicationStatus(programme.value) === 'Rejected';

	if (!isRejected) {
		showModal.value = false;
		return;
	}

	const isPresentApplication = programme.value.applicationDate
		? Interval.before(DateTime.now(), VALID_APPLICATION_AGE).contains(DateTime.fromISO(programme.value.applicationDate))
		: false;

	showModal.value = isPresentApplication;
});

const merchant = useGlobalMerchant();

const onClose = () => {
	hasAcknowledgedModal.value = true;
};

</script>

<template>
	<ProgrammeApplicationRejectedModal
		v-if="programme && merchant"
		v-model:open="showModal"
		:merchant="merchant"
		:programme="programme"
		@after:leave="onClose"
	/>
</template>
